// Textos do sentimento do cliente. O emoji e o nome de cada nível vêm daqui
// (o servidor manda só a chave: muito_satisfeito, satisfeito...).

const PT = {
  NEUXS_SENTIMENTO: {
    NIVEIS: {
      muito_satisfeito: 'Muito satisfeito',
      satisfeito: 'Satisfeito',
      neutro: 'Neutro',
      insatisfeito: 'Insatisfeito',
      irritado: 'Irritado',
    },
    TENDENCIA: {
      melhorando: 'melhorando',
      piorando: 'piorando',
      estavel: 'estável',
    },
    QUEM: {
      ia: 'com a IA',
      equipe: 'com a equipe',
      fila: 'esperando atendente',
    },
    TITULO: 'Sentimento do cliente',
    HISTORICO: 'Como mudou nesta conversa',
    CARREGANDO: 'Carregando…',
    ERRO: 'Não consegui carregar o histórico.',
    SEM_HISTORICO: 'Ainda sem mudanças.',
    DICA: 'Analisado pela IA a partir das mensagens do cliente.',
  },
};

export default { pt_BR: PT, en: PT };
